var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef, useState, useEffect } from 'react';
import useStyles from './styles';
import { useTheme } from 'react-jss';
import clsx from 'clsx';
const Icon = (_a) => {
    var { name, height, width, color = null, disabled = false, variant = 'regular', onClick = null, customClassName = '', inlineStyles = {}, innerRef = null, fill } = _a, rest = __rest(_a, ["name", "height", "width", "color", "disabled", "variant", "onClick", "customClassName", "inlineStyles", "innerRef", "fill"]);
    const ref = useRef(null);
    const [isMounted, setMounted] = useState(false);
    const theme = useTheme();
    const classes = useStyles({ theme });
    const iconStyle = clsx({
        [classes.container]: true,
        [classes[color]]: !disabled && color,
        [classes.colorDefault]: variant === 'contrast' && (!disabled && !color),
        [classes.disabled]: disabled,
        [classes[`${color}_contrast`]]: !disabled && variant === 'contrast',
        [customClassName]: Boolean(customClassName),
        [classes.clickable]: !!onClick,
    });
    useEffect(() => {
        const lazyIcon = () => {
            //Forçando uma re-renderização para sincronizar a ref atual (ref.current) com props.name
            setMounted(false);
            import(`./icons/${name}.js`)
                .then(module => {
                //Atribuindo novo módulo à ref atual (Será atualizado no fim da execução do efeito)
                ref.current = module[name];
                /*
                    Necessário porque React ignora atualizações de estado repetidas.
                    https://reactjs.org/docs/hooks-reference.html#bailing-out-of-a-state-update
                */
                setMounted(true);
            });
            //todo: mensagens de erro personalizadas
        };
        lazyIcon();
    }, [name]);
    if (!isMounted)
        return null;
    const { current: IconComponent } = ref;
    return (React.createElement("a", { className: iconStyle, onClick: onClick ? onClick : () => { }, style: inlineStyles, ref: innerRef },
        React.createElement(IconComponent, Object.assign({ height: height === null || height === void 0 ? void 0 : height.toString(), width: width === null || width === void 0 ? void 0 : width.toString(), fill: fill }, rest))));
};
export { Icon };
//# sourceMappingURL=Icon.js.map